"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.form.title.edit': 'Edit Branch',
    'branch.form.title.add': 'Add Branch',
    'branch.form.back': 'Back',
    'branch.form.name.label': 'Name',
    'branch.form.name.placeholder': 'Branch name',
    'branch.form.color.label': 'Color',
    'branch.form.color.placeholder': 'Branch color',
    'branch.form.description.label': 'Description',
    'branch.form.description.placeholder': 'Description',
    'branch.form.submit.update': 'Update Branch',
    'branch.form.submit.create': 'Create Branch',
};
